import { useStateManager } from "@bcm-dev/bcms-vite";
import { TableBody, TableColumnContainer, TableColumnView, TableView } from "components/shared";
import React from "react";
import "./styles.css";
import "./mobile.css";

//import NonNachaTemplateListTableRow from "../NonNachaTemplateListTableRow";
import { NoEntriesTableRow } from "components/shared/views/TableView/components/NoEntriesTableRow";
import TASPositivePayImportChecksTemplateListTableRow from "../TASPositivePayImportChecksTemplateListTableRow";
/**
 * @function TASPositivePayImportChecksTemplateListTable
 * @return {React.Component}
 * @exported true
 * @description This is the non nacha template table for NonNachaTemplateListWidget
 */
export default function TASPositivePayImportChecksTemplateListTable(props) {
    const { data } = useStateManager();
    const hasTemplates = data.templates.length > 0;
    
    const rows = data.templates.reduce((acc, item) => {
        acc.push(
            <TASPositivePayImportChecksTemplateListTableRow key={ item.id } templateName={ item.name } /> 
        );
        return acc;
    }, []);

    return (
        <TableView className="tas-positive-pay-import-checks-template-list-table">
            { hasTemplates && 
            <TableColumnContainer className="" >
                <TableColumnView className="template-name-col" text="Template Name" />
                <TableColumnView className="transaction-type-col" text="" />
                <TableColumnView className="edit-col text-center" text="Edit" />
                <TableColumnView className="delete-col text-center" text="Delete" />
            </TableColumnContainer>
            }
            <TableBody>
                { rows }
                { !hasTemplates && <NoEntriesTableRow text="You do not have any templates setup." colSpan="4" /> }
            </TableBody>
        </TableView>
    )
}
